<template>
    <div class="step-layout">
        <!-- ---------------------------- Step Intro Section ---------------------------- -->
        <section class="step-layout-left frame_partner">
            <div class="step-layout-container">
                <div class="progressbar">
                    <ul>
                        <li class="completed">Buy Home</li>
                        <li>Contact Details</li>
                    </ul>
                </div>
                <h2
                    class="intro-title"
                    data-aos="fade-up"
                    data-aos-duration="1300"
                >
                    These questions help us reach<br />
                    out to explain all about our<br />
                    Down Payment Assistance Option!
                </h2>
                <div class="button_box">
                    <button class="custom_button" @click="goBack">
                        <i class="fas fa-arrow-circle-left"></i>Back
                    </button>
                </div>
            </div>
        </section>
        <!-- -------------------------- Step Form Section -------------------------- -->
        <section class="step-layout-right content_from_partner">
            <div
                class="step-layout-container"
                data-aos="fade-left"
                data-aos-duration="1500"
            >
                <h2 class="title">
                    Help us to connect with you to understand your needs better!
                </h2>
                <form
                    class="text-center"
                    action="#"
                    @submit.prevent="submitJoinWaitList"
                >
                    <div class="form-group input-group-lg">
                        <input
                            type="text"
                            class="form-control"
                            :class="nameError ? 'is-invalid' : ''"
                            v-model="name"
                            placeholder="Full Name"
                        />
                        <div
                            class="text-left invalid-feedback"
                            v-if="nameError"
                        >
                            {{ nameMsg }}
                        </div>
                    </div>
                    <div class="form-group input-group-lg">
                        <input
                            type="email"
                            class="form-control"
                            :class="emailError ? 'is-invalid' : ''"
                            v-model="email"
                            placeholder="E-mail"
                        />
                        <div
                            class="text-left invalid-feedback"
                            v-if="emailError"
                        >
                            {{ emailMsg }}
                        </div>
                    </div>
                    <div class="form-group input-group-lg">
                        <input
                            type="text"
                            v-mask="'###-###-####'"
                            v-model="phone"
                            class="form-control"
                            :class="phoneError ? 'is-invalid' : ''"
                            placeholder="Phone"
                        />
                        <div
                            class="text-left invalid-feedback"
                            v-if="phoneError"
                        >
                            {{ phoneMsg }}
                        </div>
                    </div>
                    <button
                        type="submit"
                        class="submit-btn"
                        :disabled="isLoading"
                        :style="
                            isLoading ? 'opacity: 0.6;cursor: not-allowed;' : ''
                        "
                    >
                        {{ isLoading ? "Processing..." : "Submit" }}
                    </button>
                </form>
            </div>
        </section>
    </div>
</template>

<script>
import axios from "axios";
import {
    required,
    email,
    minLength,
    maxLength,
} from "vuelidate/lib/validators";
export default {
    name: "WaitListForm",
    data() {
        return {
            name: "",
            email: "",
            phone: "",
            isLoading: false,
        };
    },
    computed: {
        nameError() {
            if (this.$v.name.$error) {
                return true;
            } else {
                return false;
            }
        },
        nameMsg() {
            if (this.$v.name.$error) {
                if (!this.$v.name.minLength) {
                    return "Name must be atleast 3 characters";
                } else if (!this.$v.name.required) {
                    return "Name cannot be empty";
                } else {
                    return "Please check your input";
                }
            } else {
                return "";
            }
        },
        emailError() {
            if (this.$v.email.$error) {
                return true;
            } else {
                return false;
            }
        },
        emailMsg() {
            if (this.$v.email.$error) {
                if (!this.$v.email.required) {
                    return "Email is required";
                } else if (!this.$v.email.email) {
                    return "Email must be a valid email address";
                } else {
                    return "Please check your input";
                }
            } else {
                return "";
            }
        },
        phoneError() {
            if (this.$v.phone.$error) {
                return true;
            } else {
                return false;
            }
        },
        phoneMsg() {
            if (this.$v.phone.$error) {
                if (!this.$v.phone.required) {
                    return "Phone is required";
                } else if (!this.$v.phone.minLength) {
                    return "Phone must be a valid phone number";
                } else {
                    return "Please check your input";
                }
            } else {
                return "";
            }
        },
    },
    validations: {
        name: {
            required,
            minLength: minLength(3),
        },
        email: {
            required,
            email,
        },
        phone: {
            required,
            minLength: minLength(12),
            maxLength: maxLength(12),
        },
    },
    methods: {
        goBack() {
            window.location.href = "/buying-option";
        },
        submitJoinWaitList() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.isLoading = true;
                const formData = new FormData();
                formData.append("name", this.name);
                formData.append("email", this.email);
                formData.append("phone", this.phone);
                formData.append(
                    "message",
                    "I want to join the waitlist for partnership buying"
                );
                axios
                    .post(`/wait-list/join/request`, formData)
                    .then((response) => {
                        window.location.href = `/wait-list/join/confirmation`;
                    })
                    .catch((error) => {
                        console.error(error.response.data);
                    })
                    .finally((result) => {
                        this.isLoading = false;
                    });
            }
        },
    },
};
</script>
